// extracted by mini-css-extract-plugin
module.exports = {"loadingWrapper":"CircleLoading_loadingWrapper__kunIP","spin":"CircleLoading_spin__mTNs6"};